// ══════════════════════════════════════════════════════════════
// envioEmails.js — MAPASAC ERP v2026
// Utilidades para envío de emails
// Ubicación: C:\MapasoftWeb\frontend\src\utils\envioEmails.js
// Zero hardcode — datos desde BD
// ══════════════════════════════════════════════════════════════

import { secureFetch } from './authInterceptor';

/**
 * Resuelve placeholders {{campo}} con datos del row
 * @param {string} texto   — "Cotización No. {{nocotizacion}} — {{ncomercial}}"
 * @param {object} datos   — parentRow con los valores
 * @returns {string}       — "Cotización No. 74 — MAPASAC S.A."
 */
export const resolvePlaceholders = (texto, datos) => {
  if (!texto || !datos) return texto || '';
  return texto.replace(/{{([^}]+)}}/g, (match, key) => {
    const trimmed = key.trim();
    return datos[trimmed] !== undefined ? datos[trimmed] : match;
  });
};

/**
 * Ejecuta el envío del email
 * Extraído de EnvioEmails.jsx → handleEnviar
 * @param {object} payload  — { idreporte, id, para, cc, asunto, mensaje }
 * @param {string} token    — JWT token
 * @returns {object}        — { ok, message }
 */
export const sendEmail = async (payload, token) => {
  const response = await secureFetch('/api/sqlexec_generico/export/reporte', {
    method: 'POST',
    headers: {
      'Content-Type':  'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({
      ...payload,
      formato: 'email'
    })
  });

  const data = await response.json();

  if (!response.ok) {
    const err = new Error(data.error?.message || data.message || 'Error enviando email');
    // Propagar el code del backend (ej. SERVICIO_NO_CONFIGURADO -> 409) para
    // que el caller le dé un título propio sin depender del texto del mensaje.
    err.code = data.error?.code || data.code || null;
    err.status = response.status;
    throw err;
  }

  return data;
};